import type { AtaAttachment } from "../../services/meeting.service";

export interface MeetingEditorState {
  readonly name: string;
  readonly number: number;
  readonly date: string;
  readonly location: string;
  readonly legenda: string;
  readonly observacoes: string;
  readonly anexos: readonly AtaAttachment[];
  readonly responsavel_id: number | null;
  readonly hora_inicio: string | null;
  readonly hora_fim: string | null;
}

export interface MeetingAutoSaveData {
  readonly name: string;
  readonly number: number;
  readonly date: string;
  readonly location: string;
  readonly legenda: string | null;
  readonly observacoes: string | null;
  readonly anexos: readonly AtaAttachment[];
  readonly responsavel_id: number | null;
  readonly hora_inicio: string | null;
  readonly hora_fim: string | null;
  readonly _changeTimestamp: number;
}

function haveSameAttachments(
  first: readonly AtaAttachment[],
  second: readonly AtaAttachment[]
): boolean {
  return first.length === second.length && first.every((item, index) =>
    item.nome === second[index]?.nome && item.url === second[index]?.url
  );
}

export function mergeRefetchedMeetingState(
  localState: MeetingEditorState,
  previousServerState: MeetingEditorState | null,
  refetchedState: MeetingEditorState
): MeetingEditorState {
  if (!previousServerState) return refetchedState;

  return {
    ...refetchedState,
    legenda: localState.legenda === previousServerState.legenda
      ? refetchedState.legenda
      : localState.legenda,
    observacoes: localState.observacoes === previousServerState.observacoes
      ? refetchedState.observacoes
      : localState.observacoes,
    anexos: haveSameAttachments(localState.anexos, previousServerState.anexos)
      ? refetchedState.anexos
      : localState.anexos,
    responsavel_id: localState.responsavel_id === previousServerState.responsavel_id
      ? refetchedState.responsavel_id
      : localState.responsavel_id,
  };
}

export function mapEditorStateToAutoSave(
  state: MeetingEditorState,
  changeTimestamp: number
): MeetingAutoSaveData {
  return {
    name: state.name,
    number: state.number,
    date: state.date,
    location: state.location,
    legenda: state.legenda || null,
    observacoes: state.observacoes || null,
    anexos: state.anexos.map((item) =>
      item.url === undefined
        ? { nome: item.nome }
        : { nome: item.nome, url: item.url }
    ),
    responsavel_id: state.responsavel_id,
    hora_inicio: state.hora_inicio || null,
    hora_fim: state.hora_fim || null,
    _changeTimestamp: changeTimestamp,
  };
}
